import { Stack } from 'expo-router';

export default function OnboardingLayout() {
  return (
    <Stack
      screenOptions={{
        headerShown: false,
        animation: 'slide_from_right',
      }}>
      <Stack.Screen name="stakeholder-type" />
      <Stack.Screen name="location-check" />
      <Stack.Screen name="claim-property" />
    </Stack>
  );
}
